<template>
	<div
		class="component c-navigation"
		:class="{ dark: this.$root.navigation.dark_mode }"
	>
		<div
			class="c-navigation__app-bar border-b height-100 padding-r-6 position-relative d-flex justify-content-between  align-items-center"
		>
			<div v-if="logo_image" class="c-navigation__logo margin-x-24">
				<a :href="continue_url"
					><img :src="logo_image + '?width=120'" :alt="logo_title"
				/></a>
			</div>
			<button
				role="button"
				class="c-navigation__menu-button margin-r-12 flex-shrink-0"
				:aria-expanded="is_menu_open"
				aria-label="Toggle main navigation menu"
				:class="is_menu_open ? 'is-active' : ''"
				@click="toggle_menu"
			>
				<span class="line-1"></span>
				<span class="line-2"></span>
				<span class="line-3"></span>
			</button>
			<div
				class="c-navigation__offcanvas s-common__scrollbar position-fixed"
				:class="is_menu_open ? 'is-open' : ''"
				@keyup.esc="close_menu"
			>
				<ul
					class="margin-y-auto c-navigation__items reset-list d-flex flex-wrap-wrap"
				>
					<template v-for="link in links">
						<li
							:key="link.url"
							class="c-navigation__item width-100 bp-768:width-33 bp-1280:width-25 c-navigation__item--level-1 border-b border-r position-relative"
						>
							<a
								class="d-flex flex-direction-column justify-content-center line-height-100 align-items-center  padding-24  c-navigation__url c-navigation__url--level-1 text-decoration-none "
								:class="
									current_section === link.url
										? 'is-active'
										: ''
								"
								@click.prevent="scroll_to(link.url)"
								:title="
									link.navMenuText
										? link.navMenuText
										: link.title
								"
								:tabindex="is_menu_open ? 0 : -1"
								:href="link.url"
								@focus="is_menu_open = true"
								@blur="is_menu_open = false"
								role="button"
							>
								<feather
									class="line-height-1 margin-b-16 c-navigation__url-icon"
									size="24"
									stroke-width="1"
									:type="
										icons[link.icon]
											? icons[link.icon]
											: 'link-2'
									"
								></feather>

								<span
									class=" font-weight-normal  text-align-center font-size-21 bp-1024:font-size-36 bp-1280:font-size-48 line-height-125"
									>{{
										link.navMenuText
											? link.navMenuText
											: link.title
									}}</span
								>
							</a>
						</li>
					</template>
					<template v-for="link in more_links">
						<li
							:key="link.url"
							class="c-navigation__item width-100 bp-768:width-33 bp-1280:width-25 c-navigation__item--level-1 border-b border-r position-relative"
						>
							<a
								class="d-flex  flex-direction-column justify-content-center line-height-100  padding-24 align-items-center c-navigation__url c-navigation__url--level-1 text-decoration-none "
								:title="link.title"
								:tabindex="is_menu_open ? 0 : -1"
								:href="link.url"
								@focus="is_menu_open = true"
								@blur="is_menu_open = false"
								role="button"
								target="_blank"
							>
								<feather
									class="line-height-1 margin-b-16 c-navigation__url-icon"
									size="24"
									stroke-width="1"
									type="external-link"
								></feather>
								<span
									class="font-weight-normal  text-align-center font-size-21 bp-1024:font-size-36 bp-1280:font-size-48 line-height-125"
									>{{ link.title }}</span
								>
							</a>
						</li>
					</template>
					<li
						:key="continue_url"
						class="c-navigation__item width-100 bp-768:width-33 bp-1280:width-25 flex-grow-1 flex-shrink-1 c-navigation__item--level-1 c-navigation__item--continue position-relative"
					>
						<a
							class="d-flex  flex-direction-column justify-content-center line-height-100  align-items-center  padding-24 c-navigation__url c-navigation__url--level-1 text-decoration-none "
							:title="continue_text"
							:tabindex="is_menu_open ? 0 : -1"
							:href="continue_url"
							@focus="is_menu_open = true"
							@blur="is_menu_open = false"
							role="button"
						>
							<feather
								class="line-height-1 c-navigation__url-icon margin-b-16"
								size="24"
								stroke-width="1"
								type="arrow-right"
							></feather>
							<span
								class="font-weight-normal text-align-center font-size-21 bp-1024:font-size-36 bp-1280:font-size-48 line-height-125"
								>{{ continue_text }}</span
							>
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import Navigation from './navigation';

export default {
	extends: Navigation,
	data: () => ({
		mobile_offset: -60,
		desktop_offset: -100,
	}),
};
</script>

<style scoped lang="scss">
.c-navigation {
	position: fixed;
	top: 0;
	left: 0;
	height: 100px;
	width: 100%;
	z-index: 99;
	&__app-bar {
		background: $main-color;
		border-bottom-color: $main-border-color;
		z-index: 2;
		&::after {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			content: '';
			background: $main-color;
			z-index: 0;
			box-shadow: -1px 0px 0px 0px $main-border-color;
		}
	}
	&__menu-button {
		@include base_reset();
		color: $color-safe-text;
		width: 48px;
		height: 48px;
		position: relative;
		z-index: 2;
		transition: 0.3s;
		cursor: pointer;
		.line-1,
		.line-2,
		.line-3 {
			position: absolute;
			width: 36px;
			height: 1px;
			background: $color-safe-text;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			transition: 0.3s;
		}
		.line-1 {
			transform: translate(-6px, -13px);
			width: 24px;
		}
		.line-2 {
			transform: translate(-6px, 12px);
			width: 24px;
		}
		.line-3 {
			opacity: 1;
		}

		&:hover {
			background: $color-primary;
			.line-1,
			.line-2,
			.line-3 {
				background: $text-on-primary;
			}
		}

		&.is-active {
			.line-1 {
				width: 36px;
				transform: translate(-50%, -50%) rotate(45deg);
			}
			.line-2 {
				transform: translate(-50%, -50%) rotate(-45deg);
				width: 36px;
			}
			.line-3 {
				opacity: 0;
			}
		}
	}
	&__logo {
		width: auto;
		height: 60px;
		position: relative;
		z-index: 2;
		img {
			max-height: 100%;
		}
	}
	&__offcanvas {
		top: 100px;
		left: 0;
		transform: translateY(-102%);
		z-index: -2;
		transition: 0.3s;
		width: 100%;
		height: calc(100vh - 100px);
		background: $main-color;
		overflow: auto;
		&.is-open {
			transform: none;
		}
	}
	&__items {
		border-left: solid 1px $main-border-color;
		min-height: 100%;
	}
	&__item--level-1 {
		border-bottom-color: $main-border-color;
		border-right-color: $main-border-color;
		min-height: calc(50vh - 50px);
	}
	&__item--continue {
		background: $main-gray-color;
	}
	&__url--level-1 {
		color: $main-font-color;
		height: 100%;
		overflow-wrap: break-word;
		&::after {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 3px;
			content: '';
			background: $color-primary;
			opacity: 0;
		}
		.c-navigation__url-icon {
			color: $color-primary;
		}
		&.is-active {
			&::after {
				opacity: 1;
			}
		}
		&:hover,
		&:focus {
			color: $text-on-primary;
			transition: 0.2s;
			background: $color-primary;
			.c-navigation__url-icon {
				color: $text-on-primary;
			}
		}
	}

	@media screen and (max-width: 1023px) {
		height: 60px;
		width: 100%;
		&__app-bar {
			&::after {
				box-shadow: 0px 1px 0px 0px $main-border-color;
			}
		}
		&__logo {
			height: 40px;
		}
		&__offcanvas {
			right: 0;
			top: 60px;
			transform: translateY(-102%);
			height: calc(100% - 60px);
			width: 100%;
			max-width: none;
		}
		&__items {
			border-left: none;
		}
		&__item--level-1 {
			min-height: calc(50vh - 30px);
		}
	}

	@media screen and (max-width: 767px) {
		&__item--level-1 {
			min-height: 0;
		}
		&__url--level-1 {
			&::v-deep {
				.c-navigation__url-icon {
					width: 16px;
				}
			}
		}
	}
}
</style>
